import './Article.sass';
import iconDownload from '../assets/common/file-download.svg';
import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';
import moment from 'moment';

import { useArticles } from '../api';
import getTimestamp from '../library/tools/getTimestamp';

import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import Meta from '../components/Meta';

const Article = (props) => {
	const { routeData } = props;
	const params = useParams();
	const { articles, breadcrumbs } = useArticles('', routeData.route, '', '', params.guid);

	if (!articles[0]) return null;
	const article = articles[0];
	const timestamp = getTimestamp(article.postTime || '');
	const date = moment(timestamp).format('YYYY/MM/DD');
	let tags = [];
	if (article.keyWordList) tags = article.keyWordList.split(',');

	return (
		<div className='Article'>
			<Meta data={article} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='flex-top'>
					<div className='left'>
						<h2>{article.title}</h2>

						<div className='extra-flex'>
							{routeData?.views === 'FrontF' ? null : (
								<div className='right'>
									<div className='date'>{date}</div>
								</div>
							)}

							{routeData?.views === 'FrontF' || routeData?.views === 'FrontD' ? null : <div className='tag'>{routeData.name}</div>}
						</div>
					</div>
				</div>

				{/* {routeData.views === 'FrontE' ? (
					<video controls>
						<source src={article.files || article.url} />
					</video>
				) : null} */}

				{article?.value03 ? (
					<iframe
						src={`https://www.youtube.com/embed/${article.value03}`}
						allowFullScreen='allowfullscreen'
						allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;'
						style={{ aspectRatio: '16/9' }}
						width='100%'
						title='Youtube Video'
						sandbox='allow-scripts allow-same-origin allow-presentation'
					></iframe>
				) : null}

				<div className={`content ${routeData.views}`} dangerouslySetInnerHTML={{ __html: article.contents }}></div>

				{article.files && routeData.views !== 'FrontE' ? (
					<div className='download-wrap'>
						<a href={article.files} target='_blank' rel='noreferrer noopener'>
							<div className='icon'>
								<img src={iconDownload} alt='' />
							</div>

							<div className='text'>檔案下載</div>
						</a>
					</div>
				) : null}

				{tags.length ? (
					<div className='tags'>
						{tags.map((tag) => {
							return (
								<div className='tag' key={tag}>
									{tag}
								</div>
							);
						})}
					</div>
				) : null}

				<div className='button-wrap'>
					<Link to={routeData.url} className='common-button'>
						返回列表
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Article;
